/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReleaseUpgradePath } from './releaseUpgradePath';
import { UpgradeDeploymentStatusEnum } from './upgradeDeploymentStatusEnum';
import { EC2InstancesInfo } from './eC2InstancesInfo';
import { ReleaseRegionData } from './releaseRegionData';


export interface UpgradeCheckResult { 
    current_deployment_info: Array<ReleaseRegionData>;
    /**
     * true if the list of upgrade paths contains a default upgrade path
     */
    default_path_exist: boolean;
    id: string;
    instances_info?: EC2InstancesInfo;
    status: UpgradeDeploymentStatusEnum;
    /**
     * List of upgrade paths for a deployment
     */
    upgrade_paths: Array<ReleaseUpgradePath>;
}
export namespace UpgradeCheckResult {
}


